import { createFileRoute } from "@tanstack/react-router";

import HarmonyGenetics from "~/pages/HarmonyGenetics";
import { ROUTE_STATIC } from "~/utils/routeStaticData";

export const Route = createFileRoute("/_private/meq-live-genetics")({
  staticData: ROUTE_STATIC.meqLiveGenetics,
  component: HarmonyGenetics,
});
